module.exports = __webpack_public_path__ + "static/media/HeaderLogo_HBT.f6bb9570.svg";